import {
  ADD_BUILDING,
  GET_BUILDING,
  GET_BUILDING_DWELLINGS,
  GET_BUILDINGS,
} from "../constants";
import { IBuilding } from "../reducers";

export function addBuilding(building: IBuilding, resolve: any, reject: any) {
  return {
    type: ADD_BUILDING,
    building,
    resolve,
    reject,
  };
}

export function getBuilding(resolve: any, reject: any, id: string) {
  return {
    type: GET_BUILDING,
    resolve,
    reject,
    id,
  };
}

export function getBuildings(
  resolve: any,
  reject: any,
  page: number,
  filter: string,
) {
  return {
    type: GET_BUILDINGS,
    resolve,
    reject,
    page,
    filter,
  };
}

export function getBuildingDwellings(
  resolve: any,
  reject: any,
  page: number,
  buildingId: string,
) {
  return {
    type: GET_BUILDING_DWELLINGS,
    resolve,
    reject,
    page,
    buildingId,
  };
}
